module.exports = __webpack_public_path__ + "static/img/cha1-bg.2a2cfdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha1-bg.png
// module id = PhPp
// module chunks = 1